module.exports = __webpack_public_path__ + "static/media/pil-right-ikon@3x.842f2fa0.png";